// extracted by mini-css-extract-plugin
export default {"table":"TableOfResults_table__Q88IL","caption":"TableOfResults_caption__0Bg4V","tableWrap":"TableOfResults_tableWrap__EQKIV","wrap":"TableOfResults_wrap__ZtRo7"};